<template>
  <AgeGroupNotice v-if="visible" :age-groups="ageGroups" @add-filters="handleAddFilters" />
</template>

<script setup>
import { computed, ref, watchEffect } from "vue";
import { whenI18nReady } from "#ce/components/SpFinder/i18n";
import { useFinderResults } from "#ce/components/SpFinder/composables/useFinderResults";
import { useHostElement } from "#ce/composables/useHostElement";
import AgeGroupNotice from "./components/AgeGroupNotice.ce.vue";

const catalogsReady = ref(false);

function markCatalogsReady() {
  catalogsReady.value = true;
}

whenI18nReady.then(markCatalogsReady);

const host = useHostElement();
const { settings, payload, view, mobile, commands } = useFinderResults();

const ageGroups = computed(() => payload.value?.available_age_groups ?? []);
const visible = computed(
  () =>
    catalogsReady.value &&
    Boolean(settings.value?.notices) &&
    ageGroups.value.length > 0 &&
    (mobile.value || view.value !== "map"),
);

function reflectVisibility() {
  host?.toggleAttribute("hidden", !visible.value);
}

watchEffect(reflectVisibility);

function handleAddFilters(filters) {
  commands.addFilters(filters);
}
</script>

<style>
:host {
  display: block;
}

:host([hidden]) {
  display: none;
}
</style>
